import React from 'react';
import styled from 'styled-components/macro';


import { ReactComponent as Tower1Logo } from 'images/tower-1-logo.svg';
import { ReactComponent as Tower2Logo } from 'images/tower-1-logo.svg';


const InfoBoxTower = ({ tower }) => {
    return (
        <Container>
            <Name className="h6">{tower === 'tower_1' ? 'Tower 1' : 'Tower 2'}</Name>
            <Logo>
                {tower === 'tower_1' ? <Tower1Logo /> : <Tower2Logo />}
            </Logo>
        </Container>
    );
};


export default InfoBoxTower;


const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1.25rem;
    text-align: center;
`;

const Name = styled.div`
    color: ${props => props.theme.secondary_color};
`;

const Logo = styled.div`
    svg {
        fill: ${props => props.theme.primary_color};
    }
`;
